/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：通知API
 *
 * 作成者：2021/12/2 ノア）黄
 * 最終修正者：2021/12/2 ノア）黄
 *
 */
import { apiClient } from '@/store/apis/apiClient'
import config from '@/config/config'
import {
  MasterData,
  MasterGetParam,
  MessageSend,
  ListData,
  NotificationsParam,
  NotificationsSend,
  NotificationsData,
  UpdateNotificationsParam,
  UpdateAnnounceParam,
  UpdateMessageParam
} from '@/models'

/**
 * 営業所所属ユーザ一覧取得
 *
 * @async
 * @param {MasterGetParam} reqParams パラメータ
 * @returns {Promise<MasterData>} 営業所所属ユーザ一覧
 */
export async function getUserDataWithBusinessOffice(reqParams: MasterGetParam): Promise<MasterData> {
  const res = await apiClient.post(config.api.getUserDataWithBusinessOffice, reqParams)

  return res.data.data as MasterData
}

/**
 * メッセージ登録
 *
 * @async
 * @param {MessageSend} reqParams パラメータ
 * @returns {Promise<void>}
 */
export async function messageSend(reqParams: MessageSend): Promise<void> {
  await apiClient.post(config.api.messageSend, reqParams)
}

/**
 * メッセージ削除
 *
 * @async
 * @param {MessageSend} reqParams パラメータ
 * @returns {Promise<void>}
 */
export async function messageDelete(reqParams: MessageSend): Promise<void> {
  await apiClient.post(config.api.messageDelete, reqParams)
}

/**
 * メッセージ一覧取得
 *
 * @async
 * @param {MessageSend} reqParams パラメータ
 * @returns {Promise<ListData>} メッセージ一覧
 */
export async function getMessageSendList(reqParams: MessageSend): Promise<ListData> {
  const res = await apiClient.get(config.api.getMessageSendList, {
    params: reqParams
  })

  return res.data.data as ListData
}

/**
 * メッセージ登録
 *
 * @async
 * @param {NotificationsSend} reqParams パラメータ
 * @returns {Promise<void>}
 */
export async function announceSend(reqParams: NotificationsSend): Promise<void> {
  await apiClient.post(config.api.announceSend, reqParams)
}

/**
 * 通知一覧取得する
 *
 * @async
 * @param {NotificationsParam} reqParams 通知一覧取得のパラメータ
 * @returns {Promise<NotificationsData>} 通知一覧
 */
export async function getNotificationsList(reqParams: NotificationsParam): Promise<NotificationsData> {
  const res = await apiClient.post(config.api.getNotificationsData, reqParams)

  return res.data.data as NotificationsData
}

/**
 * 通知更新
 *
 * @async
 * @param {UpdateNotificationsParam} reqParams 通知更新のパラメータ
 * @returns {Promise<void>}
 */
export async function updateNotificationsList(reqParams: UpdateNotificationsParam): Promise<void> {
  await apiClient.post(config.api.updateNotificationsData, reqParams)
}

/**
 * アナウンス一覧取得する
 *
 * @async
 * @returns {Promise<NotificationsData>} アナウンス一覧
 */
export async function getAnnounceList(): Promise<NotificationsData> {
  const res = await apiClient.get(config.api.getAnnounceData)

  return res.data.data as NotificationsData
}

/**
 * アナウンス更新
 *
 * @async
 * @param {UpdateAnnounceParam} reqParams アナウンス更新のパラメータ
 * @returns {Promise<void>}
 */
export async function updateAnnounceList(reqParams: UpdateAnnounceParam): Promise<void> {
  await apiClient.post(config.api.updateAnnounceData, reqParams)
}

/**
 * メッセージ一覧取得する
 *
 * @async
 * @returns {Promise<NotificationsData>} メッセージ一覧
 */
export async function getMessageList(): Promise<NotificationsData> {
  const res = await apiClient.get(config.api.getMessageData)

  return res.data.data as NotificationsData
}

/**
 * メッセージ更新
 *
 * @async
 * @param {UpdateMessageParam} reqParams メッセージ更新のパラメータ
 * @returns {Promise<void>}
 */
export async function updateMessageList(reqParams: UpdateMessageParam): Promise<void> {
  await apiClient.post(config.api.updateMessageData, reqParams)
}
